<h3>Roles and Permission</h3>

<table class="table">
	<thead>
		<tr>
			<th>&nbsp;</th>
			<th>&nbsp;</th>
			<th *ngFor="let appRole of appRoles" class="text-center">
				{{appRole.name}}
			</th>
		</tr>
	</thead>
	<tbody>
		<ng-container *ngFor="let section of sections">
		<tr class="table-dark">
			<td [colSpan]="2">{{section.label}} Permissions</td>
			<td *ngFor="let appRole of appRoles"
				[nzDisabled]="viewOnly"
				[nzChecked]="areAllSelected(section.wrappers, appRole.id)"
				[nzIndeterminate]="areSomeSelected(section.wrappers, appRole.id)"
				(nzCheckedChange)="setMultipleSelected(section.wrappers, appRole.id, $event)">
			</td>
		</tr>
		<tr *ngFor="let permission of section.wrappers; trackBy: trackByPermission" >
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole" class="text-center">
				<input type="checkbox" [disabled]="viewOnly" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>
		</ng-container>
	</tbody>
</table>
<ng-container *ngIf="viewOnly == false">
	<div class="row" *hasPermission="['PermissionManage']">
		<div class="col">
			<button class="btn btn-success float-end" (click)="doSubmit()">Save</button>
		</div>
	</div>
</ng-container>
